import KenoCardController from "keno/app/controllers/KenoCard";
import KenoCardControllerMobile from "keno/app/mobile/controllers/KenoCard";
import AppModel from "keno/app/models/App";
import { globalDisplayQueue } from "keno/app/modules/DisplayQueue";
import Clock from "keno/app/modules/Clock";

//temp data taken from Keno
window.KENO_GLOBALS = window.KENO_GLOBALS || {};
window.KENO_GLOBALS.API_BASE_URL = "/apis/";
window.KENO_GLOBALS.CURRENT_GAME = "1565358000";
window.KENO_GLOBALS.CURRENT_GAME_END = "1565359199";
window.KENO_GLOBALS.COUNTDOWN_END = "1565359139";
window.KENO_GLOBALS.PREVIOUS_GAME = "1565356800";
window.KENO_GLOBALS.DAILY_TOKEN_BONUS =
	window.KENO_GLOBALS.DAILY_TOKEN_BONUS || {};
window.KENO_GLOBALS.DAILY_TOKEN_BONUS.ENABLE_MODAL = false;
window.KENO_GLOBALS.COUNTDOWN_AUTO_REDIRECT = 1;
window.KENO_GLOBALS.IS_PLAYING_NEXT = false;
window.KENO_GLOBALS.CONTEST_ENTRIES = window.KENO_GLOBALS.CONTEST_ENTRIES || {};
window.KENO_GLOBALS.CONTEST_ENTRIES.enableSweepsBanner = true;

window.KENO_GLOBALS.DEVICE_TYPE = "desktop";
window.KENO_GLOBALS.DISPLAY_VIP = true;

let appModel = AppModel.create({
	currentUser: PCHUSER || {},

	gameTimestampId: parseInt(KENO_GLOBALS.CURRENT_GAME || 0, 10) || 0,
	// end timestamp of the current game
	previousGameTimestampId: parseInt(KENO_GLOBALS.PREVIOUS_GAME || 0, 10) || 0,
	// end timestamp of the previous game
	gameEnd: parseInt(KENO_GLOBALS.CURRENT_GAME_END || 0, 10) || 0,
	// end time stamp for the countdown
	countdownEnd: parseInt(KENO_GLOBALS.COUNTDOWN_END || 0, 10) || 0,
	completedCardNumber: parseInt(
		document.querySelector(".cardplay").dataset.cardnum
	),

	// just a place to inject globals needed for various cases
	// app model also provides a more convenient getter for these
	GLOBALS: {
		PCH: window.PCH || {},
		KENO: window.KENO_GLOBALS || {}
	},
	globalDisplayQueue: globalDisplayQueue
});

// setup our shared Clock
Clock.setClockOffset(
	(window.KENO_GLOBALS && window.KENO_GLOBALS.CLIENT_TIME_OFFSET) || 0
);
Clock.startTicking();

let kenoCardController;
if (window.isDesktop || window.isTablet) {
	kenoCardController = new KenoCardController(appModel);
} else {
	kenoCardController = new KenoCardControllerMobile(appModel);
}
kenoCardController.route();
